import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import WorkerDto from '@/models/Workers/WorkerDto';
import BookingRoleWorkerStatus from '@/models/BookingRoleWorkers/BookingRoleWorkerStatus';
import BookingRoleWorkerSource from '@/models/BookingRoleWorkers/BookingRoleWorkerSource';
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import ConversationDto from '../Conversations/ConversationDto';

export default class BookingRoleWorkerDto extends BaseAgencyScopeEntityDto {
    bookingRoleId: string;
    bookingRole: BookingRoleDto;
    workerId = '';
    worker: WorkerDto;
    source: BookingRoleWorkerSource;
    status: BookingRoleWorkerStatus;
    bookingRoleWorkerShifts: BookingRoleWorkerShiftDto[] = [];
    isConversationCreated = false;
    conversation: ConversationDto = new ConversationDto();
}